import $ from "jquery";
import { dnbComLog, LogSeverity } from "../FunctionsCore";
const opencontentpageBody = () => {
    $(() => {
        if ($(".simple-header .call").length > 0) {
            const $callA = $(".call a");
            const callAHtml = $callA.html();
            const callAHtmlReplaced = callAHtml.replace(/[ ()-]/g, "");
            const href = `tel:${callAHtmlReplaced}`;
            $callA.attr("href", href);
            $(".phone a").attr("href", href);
            $(".phone_number a").attr("href", href);
        }
        else {
            // TODO Unclear log message
            dnbComLog(LogSeverity.INFO, "Campaign phone number is empty");
        }
        $(".hero .scroll-to-sidebar-form").on("click", (cl) => {
            cl.preventDefault();
            $("html, body").animate({
                "scrollTop": $(".sidebar_contact_cta, .leadform").offset().top - 70,
            }, 2000);
        });
        $("div.simple-header")
            .next()
            // TODO
            // Was:
            // .first(".content_card")
            // But "first" does not take any arguments, and it behaves the same whether it is passed arguments or it is not passed arguments
            // See https://api.jquery.com/first/
            .first()
            .css("padding-top", "84px");
    });
};
export { opencontentpageBody };
